import styled from "styled-components";
import { ifProp, prop, theme } from "styled-tools";
import { PropsStyled } from "../../Models/TitleInterface";
import { handleSizeType } from "../../Utilities/Sizes";

const Header = ({ tagName, ...otherProps }: PropsStyled) => {
  const Tag = tagName ? tagName : "h1";

  return <Tag {...otherProps} />;
};

const SelectColor = (color: string) => {
  switch (color) {
    case "white":
      return theme("White");
    case "black":
      return theme("Black");
    case "blue":
      return theme("Dark_Cornflower_Blue");
    case "Primary_600":
      return theme("Primary_600");
    case "Eerie_Black":
      return theme("Eerie_Black");
    default:
      return theme("Black");
  }
};

export const TitleStyled = styled(Header)`
  color: ${(props) =>
    props.color ? SelectColor(props.color) : theme("Black")};
  font-family: "Poppins";
  font-size: ${(props) => (prop("size") ? handleSizeType(props.size) : "72px")};
  text-align: ${ifProp("align", prop("align"), "center")};
  margin: ${prop("margin")};
`;
